module.exports = __webpack_public_path__ + "img/car.249fdf67.jpg";